import type { Optional } from 'utility-types';

import type { PanelToggle } from '../events';
import { panelToggle } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';

export const panelToggled = (
  context: TrackingContextValue,
  data: Optional<PanelToggle, 'panelName'>
) => {
  if (!data.panelName) return;

  panelToggle(data as PanelToggle, context);
};
